export const onClientEntry = () => {
    const script = document.createElement("script");
    script.src = "//js-eu1.hsforms.net/forms/embed/v2.js";
    script.async = true;
    script.charset = "utf-8";
    document.body.appendChild(script);
}
